export default __webpack_public_path__ + "static/media/lionsSymbol.e291dbb7.png";